window._ = require('lodash');

/**
 * We'll load jQuery and the Bootstrap jQuery plugin which provides support
 * for JavaScript based Bootstrap features such as modals and tabs. This
 * code may be modified to fit the specific needs of your application.
 */

try {
    window.Popper = require('popper.js').default;
    window.$ = window.jQuery = require('jquery');
    window.swal = require('sweetalert2');
    window.toastr = require('toastr');
    window.moment = require('moment');

    require('bootstrap');
    require('bootstrap-table');
    require('datatables.net');
    require('datatables.net-bs4');
    require('./light-bootstrap-dashboard');
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios');

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

/**
 * Next we will register the CSRF Token as a common header with Axios so that
 * all outgoing HTTP requests automatically have it attached. This is just
 * a simple convenience so we don't have to attach every token manually.
 */

let token = document.head.querySelector('meta[name="csrf-token"]');

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

// import Echo from 'laravel-echo'

// window.Pusher = require('pusher-js');

// window.Echo = new Echo({
//     broadcaster: 'pusher',
//     key: process.env.MIX_PUSHER_APP_KEY,
//     cluster: process.env.MIX_PUSHER_APP_CLUSTER,
//     encrypted: true
// });

function checkFullPageBackgroundImage() {
    $page = $('.full-page');
    image_src = $page.data('image');

    if (image_src !== undefined) {
        image_container = '<div class="full-page-background" style="background-image: url(' + image_src + ') "/>';
        $page.append(image_container);
    }
}

$(document).ready(() => {
    checkFullPageBackgroundImage();
    setTimeout(function () {
        // after 1000 ms we add the class animated to the login/register card
        $('.card').removeClass('card-hidden');
    }, 700);
});

// Fronted validation for html forms

$('.laravel-submit').click(function (e) {
    e.preventDefault();
    let hasErrors = false;

    $(this).find('i').css('display', 'none');
    $(this).find('span').addClass('spinner-border spinner-border-sm');

    //Remove earlier error messages
    $('.invalid-feedback').remove();

    $('.required').each(function (field) {
        //check if field is empty
        if (!this.value) {
            hasErrors = true;

            let name = this.name.replace('_', ' ');
            if (name === 'default cy[]') {
                name = name.replace('[]', '');
            }
            if (name.includes('[')) {
                let bracketIndex = name.indexOf('[') + 1;
                //Get substring that is placed between the brackets[], used for main and finance contacts in customer
                name = name.substring(bracketIndex, name.length - 1);
            }
            $(this).addClass('is-invalid');
            $(`<span class="invalid-feedback">${name} is required</span>`).insertAfter(this);
        }
    });

    //Specific top job sources
    let select = $("input[name *= 'job_types[]']");
    if (select.length) {
        select.each(function (field) {
            if (!this.value) {
                $('.d-block').remove();
                $(`<span class="invalid-feedback d-block">Job type is required</span>`).insertAfter(select);
            }
        });
    }

    if (!hasErrors) {
        $('.laravel-form').submit();
    } else {
        //If there are empty fields remove spinner and add default create icon
        $('.spinner-border').removeClass('spinner-border', 'spinner-border-sm');
        $(this).find('i').css('display', 'inline-block');
        toastr.error('Please fill in all the fields');
    }
});
